export const RESULTS = ['NC', 'NCO', 'CO']
